import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CookieService } from 'ngx-cookie-service';

import { FuseShortcutsComponent } from './shortcuts.component';
import { StoreModule } from '@ngrx/store';
import { FAVORIS, favorisReducer } from './favoris/favoris.state';
import { EffectsModule } from '@ngrx/effects';
import { FavorisEffects } from './favoris/favoris.effects';
import { FavorisFacade } from './favoris/favoris.facade';
import { Favoris } from './favoris/favoris.model';
import { FavorisService } from './favoris/favoris.service';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { DEFAULT_DATE_FORMATS } from 'app/shared/utils/default-date-formats';
import { UserEffects } from 'app/main/user/user.effects';
import { UserFacade } from 'app/main/user/user.facade';
import { User } from 'app/main/user/user.model';
import { UserService } from 'app/main/user/user.service';
import { USER, userReducer } from 'app/main/user/user.state';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        FuseShortcutsComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        FlexLayoutModule,

        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatListModule,
        MatTooltipModule,
        StoreModule.forFeature(USER, userReducer),
        StoreModule.forFeature(FAVORIS, favorisReducer),
        EffectsModule.forFeature([FavorisEffects, UserEffects,]),
    ],
    exports: [
        FuseShortcutsComponent,
        TranslateModule
    ],
    providers: [
        { provide: User, useClass: UserService },
        UserFacade,
        UserService,
        CookieService,
        { provide: Favoris, useClass: FavorisService },
        FavorisService,
        FavorisFacade,
        { provide: MAT_DATE_FORMATS, useValue: DEFAULT_DATE_FORMATS }
    ]
})
export class FuseShortcutsModule {
}
